import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { productCategoryDetail } from '@/features/product/api'
import { ProductCategoryUpdateForm } from '@/features/product/components/product-category-form'

export const Route = createFileRoute('/_app/product/category/$id/update')({
	loader: async ({ context: { qc }, params }) => {
		const { id } = params
		await qc.ensureQueryData(productCategoryDetail.qry({ id }))
	},
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/product', 'Produk'],
					['/product/category', 'Kategori'],
					['/product/category/$id/edit', 'Edit'],
				]}
			/>
			<PageCard>
				<PageCard.Header title="Edit Kategori" />
				<ProductCategoryUpdateForm />
			</PageCard>
		</PageLayout>
	)
}
